// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text--YoMLH{overflow-wrap:break-word}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/RightPanel/Notes/components/ViewFullNoteModal/full-note-modal.module.scss"],"names":[],"mappings":"AAAA,aACE,wBAAA","sourcesContent":[".text {\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": "text--YoMLH"
};
export default ___CSS_LOADER_EXPORT___;
